/**
 * Duplicate layout file of the similar PPC component.
 * The goal is for the ContentUpdateCarousel.tsx to use this layout as well but we
 * need to align the design decisions first
 *
 * When the post page is released. We can swap the sustainability page to use this layout instead of `ContentUpdateCarousel.tsx`
 */

import styled from '@emotion/styled';
import { useCallback } from 'react';
import { colors, spacing } from '../../../utils/styleguide';
import ContentUpdateCard from './ContentUpdateCard';
import Container from '../layout/Container';
import SectionTitle from '../SectionTitle';
import Carousel from '../carousel/Carousel';
import { useRouter } from 'next/router';

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: ${spacing[6]}px;
`;

type Props = {
  sectionTitle: string;
  posts: {
    id: string;
    publishedAt: string;
    location?: string;
    initiativeTitle?: string;
    caption: string | null;
    imageSrc?: string;
    imageAlt: string;
    iconSrc?: string;
    iconAlt: string;
  }[];
  backgroundColor?: string;
};
const ContentUpdateCarousel = ({ sectionTitle, posts }: Props) => {
  const router = useRouter();

  const onClick = useCallback(
    (postId: string) => {
      router.push(`/posts/${postId}`);
    },
    [router],
  );
  return (
    <>
      <StyledContainer backgroundColor={colors.grey50}>
        <SectionTitle title={sectionTitle} />
        <Carousel differentNrOfSlidesPerBreakpoint>
          {posts?.map((post) => {
            return (
              <ContentUpdateCard
                postId={post.id}
                publishedAt={post.publishedAt}
                key={post.id}
                imageSrc={post.imageSrc}
                imageAlt={post.imageAlt}
                primaryColor={colors.darkGrey}
                caption={post.caption}
                iconSrc={post.iconSrc}
                iconAlt={post.iconAlt}
                location={post.location}
                onClick={onClick}
                initiativeTitle={post.initiativeTitle}
              />
            );
          })}
        </Carousel>
      </StyledContainer>
    </>
  );
};

export default ContentUpdateCarousel;
